/**
 * Color constants for activity types and tracks.
 *
 * Color palettes are now managed in IndexedDB via colorPalettes store.
 * This file only contains the fallback default color.
 *
 * @see src/db/data/initialColorPalettesData.js - For palette definitions
 * @see src/stores/colorPalettes.js - For palette store
 */

/**
 * Default color for unknown activity types (Pink 800)
 * Used as fallback when colorId lookup fails
 */
export const DEFAULT_COLOR = '#9D174D';
